import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Dash from "./components/Dash";
import SKUDashboard from "./components/SKUDashboard";
import InfoSection from "./components/InfoSection";
import CorAdmin from "./components/CorAdmin";
import Analytics from "./components/Analytics";
import CreateAdmin from "./components/CreateUsers";
import BatchManagement from "./components/BatchManagement";
import SKUDetails from "./components/SKUDetails";
import ContactUs from "./components/SupportCenter";
import UpdateBatch from "./components/UpdateBatchDetails";
import ForgotPassword from "./components/ForgotPassword";
import ChangePassword from "./components/changePassword";
import CreateProduction from "./components/createProduction";
import useAutoLogout from "./components/useAutoLogout";
import UpdateUsers from "./components/UpdateUsers";
import useMidnightRedirect from "./components/useMidnightRedirect";
import RecallBatch from "./components/recallBatch";

import UpdateSKUDetails from "./components/UpdateSKUDetails";
import License from "./components/License";
import { stopSSE } from "./components/realtime";

function RoutesData() {
  const navigate = useNavigate();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";

  const handleLogoutSocket = () => {
    stopSSE();
  };
  /* ✅ Auto logout (30 min inactivity) */
  useAutoLogout(() => {
    handleLogoutSocket();
    sessionStorage.clear();
    fetch('/company.json')
      .then((res) => res.json())
      .then((data) => {
        sessionStorage.setItem('companyName', data.name);
        sessionStorage.setItem('companyLogo', data.logo);
        sessionStorage.setItem('baseURL', data.baseURL);
      })
      .catch((err) => console.error('Error fetching company data:', err));
    navigate("/", { replace: true });
  });

  /* ✅ Midnight redirect ONLY if logged in */
  useMidnightRedirect(isLoggedIn, "/dashboard");

  return (
    <>
      <Header
        isSuperAdmin={isSuperAdmin}
        setIsSuperAdmin={setIsSuperAdmin}
      />

      <Routes >
        <Route
          path="/"
          element={
            <div className="main-content">
              <InfoSection />
            </div>
          }
        />
        <Route
          path="/dashboard"
          element={<Dash />}
        />
        <Route
          path="/sku-dashboard"
          element={<SKUDashboard />}
        />
        <Route path="/users" element={<CorAdmin />} />
        <Route path="/create-admin" element={<CreateAdmin />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/details-sku" element={<SKUDetails />} />
        <Route path="/update-sku" element={<UpdateSKUDetails />} />
        <Route path="/update-batch" element={<UpdateBatch />} />
        <Route path="/support-center" element={<ContactUs />} />
        <Route path="/batch-management" element={<BatchManagement />} />
        <Route path="/license" element={<License />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/create-production" element={<CreateProduction />} />
        <Route path="/update-users" element={<UpdateUsers />} />
        <Route path="/recall-batch" element={<RecallBatch />} />
      </Routes>

      <Footer />
    </>
  );
}

export default RoutesData;
